import React from 'react';
import {SVGIcon} from '@homeaway/react-svg';
import {INVITE__24} from '@homeaway/svg-defs';
import {namedEvents} from '../../utils/edap';
import {TrackingContext} from '@homeaway/react-event-tracking/lib/transpiled/index';

const signUpRE = /(def%26service%3D){1}(.*\.com)?.*/;

export class SignUp extends React.Component {
    static contextType = TrackingContext;
    edapTrigger() {
        let actionLocation = 'header.signup';
        const eventField = {
            actionlocation: actionLocation
        };
        this.context.trigger(namedEvents.HEADER_LINK_CLICK, eventField);
    }

    getSignupData(items) {
        let signUpItem = items.find((item) => item.cssClass.includes('traveler'));
        return signUpItem;
    }

    createSignupHandler = (item) => {
        return (event) => {
            if (!item.link) {
                return;
            }

            this.edapTrigger(item);

            if (this.props.travelerLoginClickHandler) {
                event.stopPropagation();
                event.preventDefault();
                this.props.travelerLoginClickHandler();
                return;
            }

            let doubleEncodedURI = encodeURIComponent(encodeURIComponent(window.location.pathname + window.location.search));

            // if login, perform specific link update
            let newLink = item.link.replace(
                signUpRE,
                `$1${doubleEncodedURI}&kmsi=true`
            );

            if (newLink !== item.link) {
                event.stopPropagation();
                event.preventDefault();
                window.location.assign(newLink);
            }
        };
    }

    render() {
        if (!this.props.items) {
            return null;
        }
        const signUp = this.getSignupData(this.props.items);
        return (
            <a className="site-header-nav__link" data-bypass="true" href={signUp.link} onClick={this.createSignupHandler(signUp)} rel="nofollow">
                <div className="site-header-nav__signup">
                    <SVGIcon inlineFlex markup={INVITE__24}/><span className="site-header-nav__icon-label">{this.props.linkText}</span>
                </div>
            </a>

        );
    }
}
